import { IconButton } from '@mui/material';
import { CloseIcon } from 'assets/icons';
import clsx from 'clsx';
import { ReactElement, ReactNode } from 'react';

export interface DrawerHeaderProps {
  className?: string;
  onClose?: () => void;
  hideCloseButton?: boolean;
  noDivider?: boolean;
  children?: ReactNode;
  cancelLabel: string;
}

/**
 * DrawerHeader can be used to add themed header to the Drawer.
 */
export function DrawerHeader({
  className,
  onClose,
  hideCloseButton,
  noDivider,
  children,
  cancelLabel,
}: Readonly<DrawerHeaderProps>): ReactElement<DrawerHeaderProps> {
  return (
    <header className={clsx('p-6 pb-2', className)}>
      {!hideCloseButton && (
        <IconButton size="small" className="absolute right-4 top-4" aria-label={cancelLabel} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
      {children}
      {!noDivider && <hr className="-mx-2 mb-0 mt-4 border-0 border-b border-divider" />}
    </header>
  );
}
